
import { Checkbox,  TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import {

    StarChartCloneItemProps,

} from "../../types/types";




const StarChartOrgCloneItem: React.FC<StarChartCloneItemProps> = ({
    organizationName
}) => {


  const [studentChecked, setStudentChecked] = useState<boolean>(false)





  return (
    <TableRow style={{borderBottom:"1px solid rgb(221 221 221)" , width:"100%"}}>
      <TableCell style={{ borderBottom: 0 ,padding:"2px 12px" }}>
        <Checkbox
          checked={studentChecked}
          onChange={(e) => {
            setStudentChecked(e.target.checked)
          }}
        />
      </TableCell>

      <TableCell style={{ borderBottom: '0', textAlign: 'left',padding:"2px 12px" }}>
 
          {organizationName}
     
      </TableCell>
     

    </TableRow>

  )
}

export default StarChartOrgCloneItem
